// extracted by mini-css-extract-plugin
module.exports = {"declaration-modal":"DeclarationFormModal-module__declaration-modal___3vqqV","declarationModal":"DeclarationFormModal-module__declaration-modal___3vqqV"};